import stockAPI from "@/utility/api.js";

const state = {
  priceToEarningRatio: [],
  income: {}
};

const getters = {
  priceToEarningRatio(state) {
    const initData = [
      {
        year: 2019,
        level: "A",
        EPS_price_earnings_ratio: 19.044931709345125,
        EBIDTA_price_earning_ratio: 12.003445263975156
      }
    ];
    if (!state.priceToEarningRatio) {
      return initData;
    } else {
      return state.priceToEarningRatio;
    }
  },
  income(state) {
    return state.income;
  }
};

const mutations = {
  priceToEarningRatio(state, res) {
    state.priceToEarningRatio = [...res];
  },
  income(state, res) {
    state.income = { ...res };
  }
};

const actions = {
  async fetchPriceToEarningRatio({ commit }) {
    const res = await stockAPI.GET(`api/filter/per`);
    if (res) {
      commit("priceToEarningRatio", res);
      // return Promise.resolve();
    }
  },
  async fetchIncome({ commit }) {
    const res = await stockAPI.GET(`api/filter/income_statistics`);
    if (res) {
      commit("income", res);
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
